import { Field, ID, InputType } from 'type-graphql'
import { QueryArgs } from '../../action'
import type { AiUsageRecord } from './AiUsageRecord'

@InputType()
export class GetAiUsageListArgs extends QueryArgs<AiUsageRecord> {
  /** Target owner to read — a `User._id` (User scope) or `Tenant._id` (Tenant scope). The caller supplies this explicitly and must hold `canManageAiBilling`. */
  @Field(() => ID)
  ownerId: string
}
